import {menuStore} from "./store";
import {mapState} from 'ui.vue3.pinia'

export const Special = {
    props: {
        ar1Item: Object
    },
    computed: {
        ...mapState(menuStore, ['additional_sale']),
        imgBanner() {
            let src = this.additional_sale['display_tmenu_img_src']
            return `background-image:url(${src})`
        }
    },
    template: `
            <div class="header-nav-main-unit-body-section-top header-nav-main-unit-body-section-top_banner header-nav-main-unit-body-section-top_banner_special">
              <a class="header-nav-main-unit-body-section-banner header-nav-main-unit-body-section-banner_big header-nav-main-unit-body-section-banner_bigtext"
                   :href="additional_sale['detail_page_url']" 
                   :style="imgBanner"
               >
                <div class="header-nav-main-unit-body-section-banner-title">
                    {{ar1Item['banners']['property_title_1_value']}}
                </div>
              </a>
            </div>
    `
}